import { createSelector } from 'reselect';

const selectDoctor = (state) => state.doctorCampaign; 

const makeSelectFamily = () =>
    createSelector(selectDoctor, (state) => state?.patientDetails);

const makeSelectSlots = () =>
    createSelector(selectDoctor, (state) => state?.slots);

const makeSelectRequesting = () =>
    createSelector(selectDoctor, (state) => state?.requesting);

const makeSelectDocDetails = () =>
    createSelector(selectDoctor, (state) => state?.docdetails);

const makeSelectDepartmentDoctor = () =>
    createSelector(selectDoctor, (state) => state?.departmentDoctor);

const makeSelectUpdatedScheduleData = () =>
    createSelector(
        selectDoctor,
        (state) => state?.updatedSheduleData
    );

export {
    makeSelectFamily,
    makeSelectSlots,
    makeSelectRequesting,
    makeSelectDocDetails,
    makeSelectDepartmentDoctor,
    makeSelectUpdatedScheduleData
};
